import { Component, inject, OnInit } from '@angular/core';
import { AdminBoilerplateComponent } from '../../../../core/admin-boilerplate/feature/admin-boilerplate.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { selectAdminEvent } from '../../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../../data-services/stores/actions/admin.actions';
import { HeadlineComponent } from '../../../../events/headline/feature/headline.component';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventComplete } from '../../../../data-services/models/events/event-complete.model';
import { EventBookingComplete } from '../../../../data-services/models/event-bookings/event-booking-complete.model';
import { AdminEventWizardComponent } from '../admin-event-wizard/feature/admin-event-wizard.component';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { tap } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-manage',
  imports: [FontAwesomeModule,AdminBoilerplateComponent,HeadlineComponent,CommonModule,TableModule,RouterModule,AdminEventWizardComponent,ButtonModule,DialogModule],
  templateUrl: '../ui/manage.component.html',
  styleUrl: '../ui/manage.component.css'
})
export class AdminManageComponent implements OnInit {
  private readonly _store = inject(Store)
  private readonly _route = inject(ActivatedRoute);
  private readonly _titleService = inject(Title);
  event$ = this._store.select(selectAdminEvent(this._route.snapshot.params["id"])).pipe(
    tap(lrpEvent => {
      this._titleService.setTitle('LRPTickets.co.uk | Admin | ' + (lrpEvent?.eventHost.eventSystem.name) + (lrpEvent?.eventHost.display ? ' - ' + lrpEvent?.eventHost.name + ' | ' : ' | ') + lrpEvent?.name)
    })
  );

  sorting: "name" | "type" | "paid" = "name";

  archiveData(eventEnd: Date): boolean {
    var newDate = new Date(new Date(eventEnd).setMonth(new Date(eventEnd).getMonth() + 3));
    return newDate.getDate() < new Date().getDate();  
  }

  ngOnInit(): void {
    this._store.dispatch(adminActions.getEvent({ eventRef: this._route.snapshot.params["id"] }));
  }

  eventBookings(event: EventComplete): EventBookingComplete[] {
    return event.eventBookings.slice().sort((a, b) => a.paid ? -1 : 1);
    // switch (this.sorting) {
    //   case "name":
    //     return event.eventBookings.slice().sort((a, b) => a.surname?.localeCompare(b.surname));
    //   case "type":
    //     return event.eventBookings.slice().sort((a, b) => a.bookingType.localeCompare(b.bookingType));
    //   case "paid":
    //     return event.eventBookings.slice().sort((a, b) => a.paid ? -1 : 1);
    // }
  }

  ticketLookup(type: string, eventBooking: EventBookingComplete){
    const search = eventBooking.eventTickets.filter(x => x.name.includes(type))
    return search.length > 0
  }
}
